import * as React from 'react';
import { connect } from 'react-redux';

import NotifyHOC from '../../../../../HOC/Notifications';
import UploadImage from '../uploadMedia/v2/UploadImage';
import MediaLibraryAddModal from '../../../../libraries/mediaLibrary/MediaLibraryAddModal';
import { IApplicationState } from '../../../../../reducers';

import { Project } from '@nexxt/common/types';
import { MediaSelectType } from '../../../../libraries/mediaLibrary/MediaLibraryList';
import classnames from 'classnames';
import { questionErrorMessage } from '../../../../../constants/applicationMessage';

interface ICardImageProps {
    question: any;
    cards: any[];
    currentCard: any;
    currentProject: Project;

    optionsError: any;
    questionError: any;
    notify: any;
    selectMedia: (index: number, selectedMedia: any) => void;
    setValue: (index: number, keyName: string, value: any) => void;
    setValueWithLanguage: (
        index: number,
        keyName: string,
        value: any,
        language: string
    ) => void;
    selectedOptionType: string;
    index: number;
    editEnabled: boolean;
}

interface ICardImageState {
    isMediaLibraryOpen: boolean;
    mediaType: MediaSelectType | null;
    currentIndex: number;
}

class PopupCardImage extends React.Component<ICardImageProps, ICardImageState> {
    state = {
        isMediaLibraryOpen: false,
        mediaType: null,
        currentIndex: this.props.index
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { index } = this.props;
        if (nextProps.index !== index) {
            this.setState({ currentIndex: nextProps.index });
        }
    }

    selectMedia = (selectedMedia: any) => {
        this.props.selectMedia(this.state.currentIndex, {
            mediaURL: selectedMedia.mediaURL
        });

        this.setState({
            isMediaLibraryOpen: false,
            mediaType: null
        });
    };

    showMediaLibrary = (type: MediaSelectType) => () => {
        this.setState({
            isMediaLibraryOpen: true,
            mediaType: type
        });
    };

    closeMediaLibrary = () => {
        this.setState({
            isMediaLibraryOpen: false,
            mediaType: null
        });
    };

    render() {
        const { question, setValue, setValueWithLanguage, questionError } =
            this.props;
        const currentCard = this.props.currentCard || {};
        const { currentIndex } = this.state;
        const languages = this.props.currentProject.languages || [];
        return (
            <React.Fragment>
                {this.state.isMediaLibraryOpen && (
                    <MediaLibraryAddModal
                        isOpen={this.state.isMediaLibraryOpen}
                        setSelectedMedia={this.selectMedia}
                        notify={this.props.notify}
                        onCancel={this.closeMediaLibrary}
                        onClose={this.closeMediaLibrary}
                        type={this.state.mediaType}
                        showMediaLibrary={true}
                    />
                )}
                <div className="row">
                    <div
                        className={classnames('col-md-4 form-group', {
                            error:
                                questionError &&
                                questionError[currentIndex] &&
                                questionError[currentIndex].title
                        })}
                    >
                        <label className="form-group__label form-group__label--block">
                            Card label
                        </label>
                        <input
                            type="text"
                            className="form-group__control"
                            placeholder=""
                            onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                            ) =>
                                setValue(
                                    this.props.index,
                                    'title',
                                    event.target.value
                                )
                            }
                            value={currentCard.title}
                            disabled={!this.props.editEnabled}
                        />
                        {questionError &&
                        questionError[currentIndex] &&
                        questionError[currentIndex].title ? (
                            <span className="form-group__error-msg">
                                {questionError[currentIndex].title}
                            </span>
                        ) : null}
                    </div>
                </div>

                <UploadImage
                    label="Card content"
                    mediaURL={currentCard.mediaURL || ''}
                    appyCurrentImage={this.selectMedia}
                    error={
                        questionError &&
                        questionError[currentIndex] &&
                        questionError[currentIndex].mediaURL
                    }
                    disabled={!this.props.editEnabled}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (store: IApplicationState) => {
    const {
        projectReducer: { currentProject }
    } = store;
    return {
        currentProject
    };
};

export default NotifyHOC(connect(mapStateToProps, null)(PopupCardImage));
